import {useMutation} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {gqlStatusMessage, StatusMessage} from '../../../graphql/common.datatypes';

interface ForgotPasswordVars {
    data: { email: string; }
}

interface ForgotPasswordData {
    forgotPassword: StatusMessage
}

export const FORGOT_PASSWORD_MUTATION = gql`
    mutation forgotPassword($data: ForgotPasswordInput!) {
        forgotPassword(input: $data) {
            ${gqlStatusMessage}
        }
    }
`;

export const forgotPassword = () => useMutation<ForgotPasswordData, ForgotPasswordVars>(
    FORGOT_PASSWORD_MUTATION, {}
);

export default forgotPassword;
